module.exports = __webpack_public_path__ + "img/astoria.d2c43dca.jpg";